import React, { useState, useCallback } from 'react'
import { Button } from 'react-bootstrap'
import NewUserModal from '../../user/create-modal'
import useCurrentUser from '../../../hooks/use-current-user'
import useClientLocation from '../../../hooks/use-client-location'

const AddButton = ({
    block
}) => {
    const { toNewUser } = useClientLocation()
    const { isAdmin } = useCurrentUser()
    if (!isAdmin) {
        return null
    }
    return (
        <React.Fragment>
            <Button variant='outline-primary' size='lg' onClick={() => toNewUser()} block={block}>ADD NEW USER</Button>
        </React.Fragment>
    )
}

export default AddButton